import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-brand-bg text-brand-ink" data-testid="terms-page">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-brand-muted hover:text-brand-ink mb-6"
          >
            <ArrowLeft size={14} /> Back to home
          </Link>

          <h1 className="font-heading text-3xl sm:text-4xl font-medium tracking-tight">
            Terms & Conditions
          </h1>
          <p className="mt-2 text-sm text-brand-muted">Last updated: 29 April 2026</p>

          <div className="mt-10 space-y-6 leading-relaxed">
            <section>
              <h2 className="font-heading text-xl font-semibold">1. About these terms</h2>
              <p className="text-brand-muted">
                These Terms & Conditions govern your use of the Career Connect website
                (the “Site”) and the recruitment, HR and career-support services we
                offer (the “Services”). By using the Site or engaging us, you agree to
                these terms.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">2. About Career Connect</h2>
              <p className="text-brand-muted">
                Career Connect is an HR consultancy founded in 2026 by Priyanka Khasnis,
                operating from Parvati, Pune – 411009, Maharashtra, India. We serve
                companies and candidates across India.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">3. Services we provide</h2>
              <ul className="list-disc pl-6 text-brand-muted space-y-1">
                <li>Recruitment & hiring for tech and non-tech roles</li>
                <li>Startup HR setup, policies and onboarding</li>
                <li>Monthly HR retainer support</li>
                <li>Bulk hiring engagements</li>
                <li>CV building, interview preparation and career guidance for candidates</li>
              </ul>
              <p className="text-brand-muted">
                Specific deliverables, fees and timelines are agreed in a separate
                proposal or engagement letter for each client / candidate.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">4. Fees & payments</h2>
              <p className="text-brand-muted">
                Fees are quoted in Indian Rupees (INR), inclusive or exclusive of
                applicable taxes as specified in the proposal. Payment terms (advance,
                milestone, post-joining) are outlined in the engagement letter.
                Replacement / refund clauses are case-specific and form part of the
                agreement.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">5. Use of the Site</h2>
              <ul className="list-disc pl-6 text-brand-muted space-y-1">
                <li>Use the Site lawfully and respectfully.</li>
                <li>Do not submit false or misleading information.</li>
                <li>Do not attempt to disrupt, scrape or misuse the Site.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">6. Candidate undertakings</h2>
              <p className="text-brand-muted">
                When you share your CV or profile with us, you confirm that the
                information is accurate and that you authorise us to share it with
                relevant hiring companies for the purpose of evaluating you for open
                roles.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">7. Client undertakings</h2>
              <p className="text-brand-muted">
                When you engage us for hiring, you agree to provide accurate role
                information, evaluate shortlisted candidates fairly, and not directly
                approach our candidates outside the agreed process during the
                engagement period.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">8. Confidentiality</h2>
              <p className="text-brand-muted">
                We treat candidate and client information as confidential and share it
                only with parties who need to know for the purpose of the engagement.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">9. Intellectual property</h2>
              <p className="text-brand-muted">
                All content on this Site — text, logos, design — is the property of
                Career Connect. You may not copy, reproduce or distribute it without
                written permission.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">10. Disclaimer & liability</h2>
              <p className="text-brand-muted">
                Recruitment outcomes depend on many factors beyond our control
                (candidate decisions, market timing, client interview process). We
                provide our Services in good faith and with reasonable care; we do not
                guarantee specific outcomes unless explicitly stated in writing. To the
                maximum extent permitted by law, our total liability under any
                engagement is limited to the fees paid for that engagement.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">11. Governing law</h2>
              <p className="text-brand-muted">
                These terms are governed by the laws of India. Any disputes shall be
                subject to the exclusive jurisdiction of the courts at Pune, Maharashtra.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">12. Contact</h2>
              <p className="text-brand-muted">
                For any questions about these terms:
                <br />
                <strong>Career Connect</strong>
                <br />
                Parvati, Pune – 411009, Maharashtra, India
                <br />
                Email:{" "}
                <a
                  className="text-brand-primary underline"
                  href="mailto:hiring.careerconnect@gmail.com"
                >
                  hiring.careerconnect@gmail.com
                </a>
                <br />
                Phone:{" "}
                <a className="text-brand-primary underline" href="tel:+917774805226">
                  +91 77748 05226
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
